import { render, staticRenderFns } from "./AllTeachers.vue?vue&type=template&id=8547b918"
import script from "./AllTeachers.vue?vue&type=script&lang=js"
export * from "./AllTeachers.vue?vue&type=script&lang=js"
import style0 from "./AllTeachers.vue?vue&type=style&index=0&id=8547b918&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports